import request from '@/api/request.js'

export const getButtonConnection = ()=>request({url:'/about/button',method:'get'})

export const getOperation = () => request({ url: '/about/operation', method: 'get' })

export const getCert = () => request({ url: '/about/cert', method: 'get' })